import * as React from 'react';
import { SurveyInstanceDataService } from '../../services';
import { SurveyInstance, PagedData } from '../../models';
import { NavLink } from 'react-router-dom';
import { PagedListingState, BaseRouteProps } from '../../interfaces';
import * as moment from 'moment';
import { PagedDataGrid } from '../../components';
import { UserStore, FilterStore } from '../../stores';
import { observer, inject } from 'mobx-react';
import { computed } from 'mobx';

interface SurveyInstanceListingProps extends BaseRouteProps<{}> {
    UserStore?: UserStore;
    FilterStore?: FilterStore;
}

interface SurveyInstanceListingState extends PagedListingState<SurveyInstance> {
    orgId: number;
}

@inject('UserStore', 'FilterStore') @observer
export class SurveyInstanceListing extends React.Component<SurveyInstanceListingProps, SurveyInstanceListingState> {
    private surveyInstanceDataService = new SurveyInstanceDataService(this.props.notificationService);

    constructor(props: SurveyInstanceListingProps) {
        super(props);

        this.state = {
            entities: [],
            pageProperties: {
                currentPage: 1,
                pageSize: 20,
            },
            sortProperty: {
                id: 'Name',
                sortAscending: true
            },
            orgId: 0
        };

        this.dataFunctionWrapper = this.dataFunctionWrapper.bind(this);
    }

    @computed get organization() {
        if (this.props.FilterStore && this.props.FilterStore.organization) {
            return this.props.FilterStore.organization;
        }
        return null;
    }

    @computed get organizationName() {
        if (this.props.FilterStore && this.props.FilterStore.organization) {
            return this.props.FilterStore.organization.name;
        }
        return '';
    }

    private dataFunctionWrapper(page: number, newPage: number, pageSize: number, filter?: string, sortProperty?: string, sortDirection?: string) {
        if (this.organization) {
            return this.surveyInstanceDataService.getAllPagedByOrganization(this.organization.id, page, pageSize, filter, sortProperty, sortDirection).then((response: PagedData<SurveyInstance>) => {
                this.updateState(newPage, response);
            });
        } else {
            return this.surveyInstanceDataService.getAllPaged(page, pageSize, filter, sortProperty, sortDirection).then((response: PagedData<SurveyInstance>) => {
                this.updateState(newPage, response);
            });
        }
    }

    private updateState(pageNumber: number, data: PagedData<any>) {
        this.setState({
            entities: data.entities,
            pageProperties: Object.assign(
                {},
                this.state.pageProperties,
                {
                    currentPage: pageNumber,
                    recordCount: data.recordCount
                }
            )
        });
    }

    public render() {
        const { sortProperty, pageProperties, entities } = this.state;

        const listData = entities.map(entity => {
            return {
                'SurveyKey': entity.uniqueIdentifier,
                'User': `${entity.user.firstName} ${entity.user.lastName}`,
                'CompletedDate': entity.completedDate,
                'ExpirationDate': entity.completedDate == null ? moment(entity.expirationDate).toDate().toDateString() : null,
                'ActionKey': entity.uniqueIdentifier
            };
        });

        const actionsColumn = ({ value }: any) => {
            return <NavLink className="btn btn-default" to={`/surveyinvite/${value}`}>View</NavLink>;
        };

        const surveyKeyColumn = ({ value }: any) => {
            return <span>{value}</span>;
        };

        const completedColumn = ({ value }: any) => {
            if (value != null) {
                return <span><span className="glyphicon glyphicon-ok" />&nbsp;&nbsp;{moment(value).toDate().toDateString()}</span>;
            } else {
                return <span className="glyphicon glyphicon-remove" />;
            }
        };

        const expiresColumn = ({ value }: any) => {
            if (value != null) {
                return <span>{moment(value).toDate().toDateString()}</span>;
            } else {
                return <span />;
            }
        };

        const columnDefs = [
            { id: 'SurveyKey', title: 'Survey Key', customComponent: surveyKeyColumn },
            { id: 'User' },
            { id: 'CompletedDate', title: 'Completed', customComponent: completedColumn },
            { id: 'ExpirationDate', title: 'Expires', customComponent: expiresColumn, sortable: false },
            { id: 'ActionKey', title: 'Actions', width: '88px', customComponent: actionsColumn, sortable: false }
        ];

        return (
            <div>
                {this.organization && <div key={`organization-${this.organization.id}`} />}

                <div className="content-header">
                    <div className="content-container">
                        <div className="row">
                            <div className="col-xs-7">
                                <div className="title">
                                    Survey Invites <span className="light">for </span> '{this.organizationName}'
                                </div>
                            </div>
                            <div className="col-xs-5 text-right">
                                <NavLink className="btn btn-primary" to={'/surveyinvite/create'}>
                                    <span className="glyphicon glyphicon-plus" /> Create
                                </NavLink>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="content-body">
                    <div className="content-container">
                        {this.organization && <PagedDataGrid
                            key={this.organization.id}
                            entities={listData}
                            columns={columnDefs}
                            dataFunction={this.dataFunctionWrapper}
                            defaultSort={sortProperty}
                            pageProperties={pageProperties}
                        />}
                    </div>
                </div>
            </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/surveyinstance/SurveyInstanceListing.tsx